import React, { useRef, useMemo, useContext } from "react";
import { useHoverEvents } from "../../Containers/Origin/Origin";
import classnames from "classnames";
import Button from "../Button/Button";
import {
  createDay,
  useTimelineZoom,
  TimelineSettingsContext
} from "./TimelineHelper";
import Popup from "../Popup/Popup";

const HeaderItem = React.memo(function HeaderItem({
  value,
  nowMilisec,
  holiday
}) {
  const { key, isWeekend } = value;
  const anchorRef = useRef();
  const {
    onPopupMouseEnter,
    onPopupMouseLeave,
    onAnchorMouseEnter,
    onAnchorMouseLeave,
    isOpen
  } = useHoverEvents();
  const { width } = useTimelineZoom();
  const { HeaderButton } = useContext(TimelineSettingsContext);

  const { hoverTitle, onClick } = HeaderButton;
  return (
    <div
      className={classnames(
        "ar-timeline-grid-item ar-timeline-grid-header-item",
        {
          today: nowMilisec === key,
          weekend: isWeekend,
          holiday: Boolean(holiday)
        }
      )}
      style={{ width: `${width}px` }}
    >
      {holiday && <div className="ar-timeline-grid-header-item-holiday">F</div>}
      <Button
        onMouseOver={onAnchorMouseEnter}
        onMouseOut={onAnchorMouseLeave}
        ref={anchorRef}
        vType="link"
        onClick={() => onClick(value.key)}
      >
        <span className="text-black">{value.date.format("DD ddd")}</span>
      </Button>
      <Popup
        anchorEl={anchorRef.current}
        modifiers={{
          preventOverflow: { boundariesElement: "viewport" }
        }}
        isOpen={isOpen}
        placement={"bottom-center"}
        onMouseEnter={onPopupMouseEnter}
        onMouseLeave={onPopupMouseLeave}
      >
        <div className="bg-black text-white px-2 py-1 fs-14 rounded">
          {hoverTitle}
        </div>
      </Popup>
    </div>
  );
});

const MonthHeaderItem = ({ value }) => {
  const { date, totalDays } = value;

  const month = date.format("MMMM - YYYY");
  const { width: dayWidth } = useTimelineZoom();
  const width = `${totalDays * dayWidth}px`;

  return (
    <div className="ar-timeline-month-header-item" style={{ width }}>
      <div className="text-capitalize text-black fw-medium mx-3">{month}</div>
    </div>
  );
};

const buildMonthTimes = (times, startIndex = 0) => {
  const time = times[startIndex];
  const maxIndex = times.length - 1;

  const { date } = time;
  const currentDay = date.date();
  const daysInMonth = date.daysInMonth();

  const daysAhead = daysInMonth - currentDay;

  let endIndex = startIndex + daysAhead;
  if (endIndex > maxIndex) endIndex = maxIndex;

  const totalDays = endIndex - startIndex + 1;

  let nextIndex;
  if (endIndex !== maxIndex) nextIndex = endIndex + 1;

  const value = {
    date,
    totalDays
  };

  return { nextIndex, value };
};

const useMonthTimes = (times) => {
  const x = useMemo(() => {
    const arr = [];
    let currentIndex = 0;

    while (currentIndex !== undefined) {
      //;
      const { nextIndex, value } = buildMonthTimes(times, currentIndex);

      arr.push(value);
      currentIndex = nextIndex;
    }
    return arr;
  }, [times]);

  return x;
};
const MonthsHeader = ({ times }) => {
  const months = useMonthTimes(times);

  return (
    <div className="ar-timeline-header-months">
      {/* <div className="ar-timeline-grid-header-item ar-timeline-month-header-item justify-content-end px-3">
            Mês
          </div> */}
      {months.map((v, i) => {
        return <MonthHeaderItem key={i} value={v} />;
      })}
    </div>
  );
};

const Header = React.memo(function Header({
  virtualInfo,
  nowMilisec,
  holidays
}) {
  const { resolvedTimes, style } = virtualInfo;
  if (!resolvedTimes) return null;

  return (
    <div className="ar-timeline-header" style={style}>
      <MonthsHeader times={resolvedTimes} />
      <div className="ar-timeline-header-days d-flex">
        {/* <div className="ar-timeline-grid-item ar-timeline-grid-header-item justify-content-between justify-content-between px-3">
              <div>At.</div>
              <div>Dia</div>
            </div> */}
        {resolvedTimes.map((v) => (
          <HeaderItem
            holiday={holidays[v.key]}
            key={v.key}
            nowMilisec={nowMilisec}
            value={v}
          />
        ))}
      </div>
    </div>
  );
});

export const TimelineWeaklyConfig = {
  key: "weakly",
  title: "Mensal",
  HeaderComponent: Header,
  dateUnit: "days",
  itemsPerCycle: 14,
  getStartDate: () => {
    const now = createDay();
    return now;
  }
};
